import CashRecord from '@/views/webpc/CashierDesk/CashRecordApp/CashRecord'

// 定义路由路径数列表
export default [{
  path: '/cashRecord',
  name: '收银记录',
  component: CashRecord
}]



// WEBPACK FOOTER //
// ./src/views/webpc/CashierDesk/CashRecordApp/routers/index.js